import { code } from "@spscommerce/utils";
import { DSReactExamples } from "@spscommerce/ds-shared";

export const SpsWizardExamples: DSReactExamples = {
  substep: {
    label: 'Substep',
    examples: {
      completed: {
        jsx: code`
                <React.Fragment>
                    <SpsWizardSubstep condition={WizardSubstepConditions.COMPLETED} orderPosition="1" display="Payment Options">
                      <div>Put a Route here</div>
                    </SpsWizardSubstep>
                </React.Fragment>
            `
      },
      active: {
        jsx: code`
                  <React.Fragment>
                      <SpsWizardSubstep condition={WizardSubstepConditions.ACTIVE} orderPosition="2" display="Payment Options">
                        <div>Put a Route here</div>
                      </SpsWizardSubstep>
                  </React.Fragment>
              `
      },
      basic: {
        jsx: code`
                <React.Fragment>
                <SpsWizardSubstep condition={WizardSubstepConditions.BASIC} orderPosition="3" display="Payment Options">
                  <div>This is visibility: hidden. You can leave your route here</div>
                </SpsWizardSubstep>
            </React.Fragment>
                `
      }


    },
  },
  sidebar: {
    label: 'Sidebar',
    examples: {
      basic: {
        react: code`
        function Component() {
          const stepCallbackFn = () => {
            alert('step has been pressed');
          }
          const phaseArray = [
            {
              title: "Plan & Payment",
              disabled: false,
              steps: [
                {
                  title: "Choose a Plan",
                  percentComplete: 100,
                  active: false,
                  disabled: false,
                  callback: stepCallbackFn
                },
                {
                  title: "Payment & Billing",
                  percentComplete: 33,
                  active: true,
                  disabled: false
                },
                {
                  title: "Confirm Payment",
                  percentComplete: 0,
                  active: false,
                  disabled: false
                }
              ]
            },
            {
              title: "Implementation details",
              disabled: true,
              steps: [
                {
                  title: "Implementation details",
                  percentComplete: 0,
                  active: false,
                  disabled: true
                }, {
                  title: "Choose a Plan",
                  percentComplete: 0,
                  active: false,
                  disabled: true
                },
              ]
            }
          ];
          return (
            <div className="sfg-row">
              <div className="sfg-col-4">
                    <SpsWizardSidebar phases={phaseArray} />
                  </div>
            </div>
              )
          }
        `
      }
    }
  }
};
